export default {"src":"/_next/static/media/whitepotato.eccfe487.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};